import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "./ui/button";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("hsc_cookie_ok")) {
        const timer = setTimeout(() => setShow(true), 1200);
        return () => clearTimeout(timer);
      }
    } catch (e) { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem("hsc_cookie_ok", "1"); } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] animate-in">
      <div className="hsc-glass rounded-2xl border border-white/70 shadow-2xl p-4 flex items-start gap-3">
        <span className="grid place-items-center w-10 h-10 rounded-xl bg-primary/10 text-primary shrink-0">
          <Cookie className="w-5 h-5" />
        </span>
        <div className="flex-1">
          <p className="text-[13.5px] leading-relaxed text-slate-700">{t.cookie.text}</p>
          <Button onClick={accept} className="mt-3 rounded-full h-9 px-6 text-sm font-semibold">
            {t.cookie.accept}
          </Button>
        </div>
      </div>
    </div>
  );
}
